var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFiletype(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.91675 15.4167C2.91675 12.207 2.91675 4.58337 2.91675 4.58337C2.91675 3.20266 4.03604 2.08337 5.41675 2.08337H14.5834V12.9167C14.5834 12.9167 7.597 12.9167 5.41675 12.9167C4.04175 12.9167 2.91675 14.0351 2.91675 15.4167Z",
    fill: "#B1B3BC",
    stroke: "#B1B3BC",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5834 12.9166C14.5834 12.9166 5.89746 12.9166 5.41675 12.9166C4.03604 12.9166 2.91675 14.0359 2.91675 15.4166C2.91675 16.7973 4.03604 17.9166 5.41675 17.9166C6.33721 17.9166 10.7817 17.9166 17.0834 17.9166V2.91663",
    stroke: "#B1B3BC",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83325 15.4166H14.1666",
    stroke: "#B1B3BC",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiletype);
export default __webpack_public_path__ + "static/media/filetype.07603a1e70a3134f3d175be07d6c6009.svg";
export { ForwardRef as ReactComponent };